import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { LoggedUserQuery, LoggedUserQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(LoggedUserQuery)
@Wrapper(LoggedUserQueryHandlerBase)
export class LoggedUserQueryHandler {
    public constructor(
        http: Http
    ) { }
}
